// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'
import { getStyle } from '@helpers/getStyles'

// Styles
import styles from './Flex.module.sass'

// Interfaces
import { SpacingData } from '@interfaces/spacing'

interface FlexProps {
  children: React.ReactNode
  display?: 'flex' | 'inline-flex'
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'baseline' | 'stretch'
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'stretch'
  flexDirection?: 'row' | 'column' | 'column-reverse'
  wrap?: boolean
  columnGap?: SpacingData
  rowGap?: SpacingData
  fullHeight?: boolean
  fullWidth?: boolean
  className?: string
  spacing?: SpacingData
  center?: boolean
  onClick?: Function
}

interface CustomStyles {
  columnGap?: string
  rowGap?: string
  marginBottom?: string
}

const Flex = ({
  children,
  display = 'flex',
  alignItems,
  justifyContent,
  flexDirection = 'row',
  wrap,
  columnGap,
  rowGap,
  fullHeight,
  fullWidth,
  className = '',
  spacing,
  center,
  onClick
}: FlexProps) => {
  const isDesktop = useMediaQuery(1168)

  const customStyles: CustomStyles = {}

  if (columnGap) {
    customStyles.columnGap = getStyle(columnGap, isDesktop)
  }

  if (rowGap) {
    customStyles.rowGap = getStyle(rowGap, isDesktop)
  }

  if (spacing) {
    customStyles.marginBottom = getStyle(spacing, isDesktop)
  }

  return (
    <div
      className={`
        ${styles[display]}
        ${alignItems ? styles[`alignItems-${alignItems}`] : ''} 
        ${justifyContent ? styles[`justifyContent-${justifyContent}`] : ''}
        ${flexDirection ? styles[`flexDirection-${flexDirection}`] : ''}
        ${wrap ? styles['wrap'] : ''}
        ${fullHeight ? styles['fullHeight'] : ''}
        ${fullWidth ? styles['fullWidth'] : ''}
        ${center ? styles['center'] : ''}
        ${className}
      `}
      style={customStyles}
      onClick={() => {
        onClick && onClick()
      }}
      role={onClick ? 'button' : ''}
    >
      {children}
    </div>
  )
}

export default Flex
